import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ContentLayoutWrapper } from '../ContentLayoutWrapper';

const RowNoWrap = styled(Row)`
  flex-wrap: nowrap;
  height: ${props => props.theme.layoutHeaderContentHeight}px;
  max-width: 100%;
`;
const ColFixed = styled(Col)`
  flex: 0 0 auto;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
`;
const ColLogo = styled(Col)`
  flex: 0 0 auto;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
`;
const ColAuto = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 0;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
  overflow: hidden;
`;

export interface IAdminHeaderTopRowLayoutProps {
  boxed?: boolean;
  /** Colonna sinistra per il logo */
  logo?: React.ReactNode;
  /** Colonna centrale per il menu princiale */
  main?: React.ReactNode;
  /** Colonna destra per il menu utente */
  right?: React.ReactNode;
}
/**
 * Header Top Row Base.
 */
export function AdminHeaderTopRowLayout(props: IAdminHeaderTopRowLayoutProps) {
  const { logo, boxed, main, right } = props;

  return (
    <ContentLayoutWrapper boxed={boxed}>
      <RowNoWrap align="middle">
        {logo && <ColLogo>{logo}</ColLogo>}
        <ColAuto>{main}</ColAuto>
        <ColFixed>{right}</ColFixed>
      </RowNoWrap>
    </ContentLayoutWrapper>
  );
}
